import { features } from "@/lib/lottery-data";

const badgeLabel = { free: "Grátis", pro: "Pro", premium: "Premium" } as const;
const badgeClass = {
  free: "border-lt-border text-lt-cream3",
  pro: "border-primary/40 text-primary",
  premium: "border-accent/40 text-accent",
} as const;

const FeaturesMarquee = () => {
  // Duplica a lista para criar loop visual contínuo.
  const loop = [...features, ...features];
  return (
    <div
      className="relative overflow-hidden border-b border-lt-border bg-lt-bg2/50"
      aria-label="Funcionalidades do LotoTerminal"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-background to-transparent" />
      <div className="flex w-max animate-lt-marquee py-2.5">
        {loop.map((f, i) => (
          <div
            key={i}
            className="mx-6 flex shrink-0 items-center gap-2 font-sans text-[12px] uppercase tracking-[0.14em] text-lt-cream2"
          >
            <span className="font-serif text-[11px] italic text-primary">{f.num}</span>
            <span>{f.fullName}</span>
            <span
              className={`rounded-full border px-1.5 py-0.5 text-[9px] font-medium tracking-wider ${badgeClass[f.badge]}`}
            >
              {badgeLabel[f.badge]}
            </span>
            <span className="ml-6 text-lt-cream3/40">·</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesMarquee;